module.exports = __webpack_public_path__ + "static/media/preset-roles.fe003f69.svg";